export default __webpack_public_path__ + "media/zurb/img/b2b_ecommerce/lin_stats-dc702af751ea6a08e87780d639e316a1.png";